export const WRP_CASE_TYPE_SLUG = 'Worker Retention Program'
export const WRP_DOCUMENT = 'WRP_DOCUMENT'
export const REQUIRED_DOCUMENT = 'REQUIRED_DOCUMENT'
export const RETIREMENT_CASE_TYPE_SLUG = 'Retirement'